export const isFavorite = (favoritesIDs, id) => {
  return favoritesIDs?.includes(id);
};
